module.exports = __webpack_public_path__ + "img/detail_page-bot.16b695e3.png";